export default {
    general: {
        cancel:  'Prekliči',
        confirm: 'Potrdi',
        loading: 'Nalagam …',
        retry:   'Poskusi znova',
        copy:    'Kopiraj',
        copied:  'Kopirano',
    },
    brand: {
        product_name: 'Rezervacije',
    },
    layout: {
        switch_language: 'Switch to English',
        footer:          'Rezervacije — spletna rezervacija terminov',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetlo',
        switch_to_dark:  'Preklopi na temno',
    },
    errors: {
        generic_error:      'Prišlo je do napake',
        try_again:          'Poskusite znova čez trenutek.',
        invalid_data:       'Podatki niso veljavni. Preverite jih in poskusite znova.',
        not_found:          'Ne obstaja',
        slot_unavailable:   'Ta termin je medtem že zaseden. Izberite drugega.',
        incorrect_status:   'Rezervacija je že odpovedana ali zaključena.',
        cancel_not_allowed: 'Za odpoved je prepozno. Pokličite nas.',
    },
    validation: {
        required: 'Polje je obvezno',
        email:    'Vpišite veljaven e-poštni naslov',
    },
    not_found: {
        title:                'Strani ni',
        description:          'Preverite naslov, ki ste ga prejeli.',
        business_title:       'Rezervacije niso na voljo',
        business_description: 'Ta stran ne obstaja ali spletne rezervacije trenutno niso vključene.',
    },
    landing: {
        book:        'Rezerviraj',
        no_services: 'Trenutno ni storitev, ki bi jih lahko rezervirali na spletu.',
    },
    service: {
        back:           'Vse storitve',
        not_found:      'Te storitve ni več mogoče rezervirati.',
        step_day:       '1. Izberite dan',
        step_time:      '2. Izberite uro',
        step_details:   '3. Vaši podatki',
        no_days_month:  'V tem mesecu ni prostih terminov — poglejte naslednjega.',
        no_times:       'Ta dan ni več prostih terminov.',
        name:           'Ime in priimek',
        email:          'E-pošta',
        email_help:     'Sem pošljemo potrditev in povezavo za odpoved.',
        phone:          'Telefon',
        notes:          'Sporočilo (neobvezno)',
        marketing_consent: 'Želim prejemati obvestila in ponudbe {name} po e-pošti. Soglasje lahko kadarkoli prekličem.',
        confirm:        'Potrdi rezervacijo',
        no_payment:     'Plačilo na spletu ni potrebno.',
    },
    booking: {
        status: {
            booked:    'Potrjeno',
            completed: 'Opravljeno',
            cancelled: 'Odpovedano',
            no_show:   'Ni prišel',
        },
    },
    manage: {
        booking:                'Rezervacija',
        booked_title:           'Rezervacija je potrjena',
        booked_description:     'Shranite povezavo spodaj — z njo si rezervacijo kadarkoli ogledate ali jo odpoveste.',
        service:                'Storitev',
        when:                   'Termin',
        name:                   'Na ime',
        price:                  'Cena',
        pay_on_site:            'plačilo na kraju samem',
        keep_link:              'Vaša povezava do rezervacije:',
        book_another:           'Nova rezervacija',
        cancel:                 'Odpovej rezervacijo',
        cancel_confirm:         'Rezervacijo res odpoveste? Termin se sprosti za druge.',
        cancelled:              'Rezervacija je odpovedana',
        cannot_cancel:          'Za odpoved na spletu je prepozno — pokličite nas.',
        not_found:              'Rezervacije ni mogoče najti',
        not_found_description:  'Povezava je nepopolna ali napačna. Uporabite povezavo iz potrditvenega sporočila.',
    },
    access: {
        title: 'Vstopna koda',
        valid: 'Koda odpre vrata od {from} do {until}.',
        valid_same_day: 'Koda odpre vrata {day} od {from} do {until}.',
    },
}
